import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(_param) {
    var isDark = _param.isDark, props = _object_without_properties(_param, [
        "isDark"
    ]);
    return /*#__PURE__*/ _jsx("img", {
        src: isDark ? "/logoPNCswaps.png" : "/logoPNCswap.png",
        alt: "",
        className: "desktop-icon",
        width: 25,
        style: {
            marginRight: "8px"
        }
    });
};
export default Icon;
